import React, { Fragment, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom/dist";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { ErrorToaster } from "../components/toaster/Toaster";
import UserServices from "../../services/User";
import { deleteAlert } from "../components/sweetAlert";
import { cleanObject, Debounce } from "../../utils";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { all_routes } from "../../Router/all_routes";
import { IMAGE_BASE_URL } from "../../config/constants";

const Users = () => {

  const routes = all_routes;
  const [searchParams, setSearchParams] = useSearchParams();

  // *For Loader
  const [loader, setLoader] = useState(false);

  // *For Users
  const [users, setUsers] = useState([]);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const pageLimit = parseInt(searchParams.get("limit") || "10", 10);
  const searchText = searchParams.get("search") || "";

  // *For Get Users
  const getUsers = async (page = currentPage, limit = pageLimit) => {
    setLoader(true)
    try {
      const params = {
        ...Object.fromEntries(searchParams.entries()),
        page,
        limit
      }
      const { data } = await UserServices.getUsers(params)
      setUsers(data?.users)
      setTotalCount(data?.pagination?.total)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  // *For Delete User
  const deleteUser = async (id) => {
    try {
      const isConfirmed = await deleteAlert()

      if (isConfirmed) {
        const { message } = await UserServices.deleteUser(id);
        getUsers();

        Swal.fire({
          title: "Deleted!",
          text: message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.close();
      }
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Handle Pagination and Filters
  const handlePaginationFilter = (data) => {
    try {
      const obj = {
        ...data,
      }
      const updatedParams = {
        ...Object.fromEntries(searchParams.entries()),
        page: 1,
        ...cleanObject(obj)
      };
      Debounce(() => setSearchParams(updatedParams));
    } catch (error) {
      console.log(' handlePaginationFilter => error:', error)
    }
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="userimgname">
          <div className="product-img stock-img">
            <img src={`${IMAGE_BASE_URL}${record?.logo}`} width={"50px"} height={"auto"} style={{ objectFit: "contain", marginRight: "6px" }} />
          </div>
          {text}
        </span>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (text) => (
        <span>
          {text || '-'}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text) => (
        <span>
          {text || '-'}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <span className={`badge ${text === "Active" ? "badge-linesuccess" : "badge-linedanger"}`} >
          {text}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to={`${routes?.editUser}/${record?.id}`}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link className="confirm-text p-2" to="#" onClick={() => deleteUser(record?.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getUsers()
  }, [searchParams]);

  return (
    <Fragment>

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>User List</h4>
                <h6>Manage your users</h6>
              </div>
            </div>
            <div className="page-btn">
              <Link
                to={routes?.addUser}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Add User
              </Link>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      defaultValue={searchText}
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      onChange={(e) => handlePaginationFilter({ search: e.target.value })}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  loading={loader}
                  columns={columns}
                  dataSource={users}
                  totalCount={totalCount}
                  pageSize={pageLimit}
                  currentPage={currentPage}
                  onChange={(page, pageSize) => handlePaginationFilter({ page: page, limit: pageSize })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Users;
